var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cv-button-set",class:[`${_vm.carbonPrefix}--btn-set`, { [`${_vm.carbonPrefix}--btn-set--stacked`]: _vm.stacked }]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }